import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyFieldsModelPerformancePentad,
  selectMeteorologyFieldsModelPerformanceRounds,
  selectMeteorologyFieldsModelPerformanceSelectedRounds,
  selectMeteorologyFieldsModelPerformanceAnalysisPeriod,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';
import usePeriodType from './usePeriodType';
import useAnalysisType from './useAnalysisType';
import useVariable from './useVariable';

export default function useCanQuery() {
  const { periodType } = usePeriodType();
  const { analysisType } = useAnalysisType();
  const { variable } = useVariable();

  const pentad = useSelector(selectMeteorologyFieldsModelPerformancePentad);
  const rounds = useSelector(selectMeteorologyFieldsModelPerformanceRounds);
  const selectedRounds = useSelector(selectMeteorologyFieldsModelPerformanceSelectedRounds);
  const analysisPeriod = useSelector(selectMeteorologyFieldsModelPerformanceAnalysisPeriod);

  const canQuery = useMemo(() => {
    if (!periodType) return false;

    if (periodType === 'preset') {
      return Boolean(analysisType && variable && pentad && rounds && rounds.length > 0);
    }

    if (periodType === 'free') {
      const hasRounds = Array.isArray(selectedRounds) && selectedRounds.length > 0;
      const hasPeriod = Boolean(
        analysisPeriod?.start
        && analysisPeriod?.end
        && analysisPeriod.start !== analysisPeriod.end,
      );
      return Boolean(analysisType && variable && hasRounds && hasPeriod);
    }

    return false;
  }, [periodType, analysisType, variable, pentad, rounds, selectedRounds, analysisPeriod]);

  return { canQuery };
}
